import englishMessages from './en/en.json';
import frenchMessages from './fr/fr.json';
// eslint-disable-next-line import/prefer-default-export
export const messages: any = {
  en: englishMessages,
  fr: frenchMessages
};